<template>
  <Slider
    :slides="clues"
    title="common.clues"
    v-slot="{ currentSlide, methods: { nextSlide, prevSlide } }"
  >
      <div :class="$style.buttons">
        <span v-if="currentSlide !== 0" class="btn btn--secondary" @click="prevSlide">{{ $t('common.prevClue') }}</span>
        <div v-else></div>
        <span v-if="currentSlide !== clues.length - 1" class="btn" @click="nextSlide">{{ $t('common.nextClue') }}</span>
        <router-link v-else class="btn" :to="{name: 'quiz'}">{{ $t('common.startQuiz') }}</router-link>
      </div>
  </Slider>
</template>

<style module>
  .buttons {
    display: flex;
    justify-content: space-between;
    margin: 0 2em;
    align-self: stretch;
  }
</style>

<script>
// @ is an alias to /src
import Slider from '@/components/Slider.vue';

import shuffleArray from '../helpers/shuffleArray';

export default {
  name: 'clues',
  data() {
    return {
      slides: [],
    };
  },
  components: {
    Slider,
  },
  methods: { },
  computed: {
    clues() {
      return shuffleArray(this.$store.getters.getCluesForLevel(this.$store.getters.getLevel));
    },
  },
  created() {
    if (this.$store.getters.getClues.length === 0) {
      this.$store.dispatch('getClues');
    }
  },
};
</script>
